export default __webpack_public_path__ + "static/media/icon_3_1.e86f1595.svg";